import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiCall from "redux/services/apiCall";
import { API_CATEGORY } from "redux/services/apiTypes";

interface categoryDetailState {
  categoryDetailLoading: boolean;
  categoryDetailSuccess: boolean;
  categoryDetailRes: any;
  categoryDetailErr: unknown | null;
}

const initialState: categoryDetailState = {
  categoryDetailLoading: false,
  categoryDetailSuccess: false,
  categoryDetailRes: null,
  categoryDetailErr: null,
};

const categoryDetailSlice = createSlice({
  name: "categoryDetail",
  initialState,
  reducers: {
    clearCategoryDetail: (state) => {
      state.categoryDetailLoading = false;
      state.categoryDetailSuccess = false;
      state.categoryDetailRes = null;
      state.categoryDetailErr = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCategoryDetail.pending, (state) => {
        state.categoryDetailLoading = true;
        state.categoryDetailSuccess = false;
      })
      .addCase(getCategoryDetail.fulfilled, (state, action) => {
        state.categoryDetailLoading = false;
        state.categoryDetailSuccess = true;
        state.categoryDetailRes = action.payload;
      })
      .addCase(getCategoryDetail.rejected, (state, action) => {
        state.categoryDetailLoading = false;
        state.categoryDetailSuccess = true;
        state.categoryDetailErr = action.payload;
      });
  },
});

export const getCategoryDetail = createAsyncThunk(
  categoryDetailSlice.name,
  async (
    payload: {
      query?: string;
    },
    { fulfillWithValue, rejectWithValue }
  ) => {
    const apiData = {
      type: payload?.query ? `${API_CATEGORY}${payload.query}` : API_CATEGORY,
      apiType: "GET",
    };
    try {
      const res = await apiCall(apiData);
      return fulfillWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const { clearCategoryDetail } = categoryDetailSlice.actions;
export default categoryDetailSlice.reducer;
